import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { FTTB_BLOCK_NAME, PAGE_TYPE_EVENT_NAMES, vkPushEvent, ymPushEvent, ymPushParams } from '@fttb/common';
import { GOAL_FTTB_AND_FMC } from "../constants";
import { VkGoalEvent } from "../../../../blocks/constants";
export var sendParamsWithField = function sendParamsWithField(pageType, data) {
  ymPushParams(_defineProperty({}, pageType, data));
};
export var sendParamsWithBlockName = function sendParamsWithBlockName(pageType, data) {
  sendParamsWithField(pageType, _defineProperty({}, FTTB_BLOCK_NAME.check_address_middleform, data));
};
export var sendReachGoal = function sendReachGoal(pageType, data) {
  /** VK goal из задачи FIRST-11109 */
  vkPushEvent(VkGoalEvent.shpdLead);
  ymPushEvent(pageType === PAGE_TYPE_EVENT_NAMES.fmc ? GOAL_FTTB_AND_FMC.ConvergentTariffCallbackLongFormNew : GOAL_FTTB_AND_FMC.HomeTariffCallbackLongForm, _defineProperty({}, pageType, _defineProperty({}, FTTB_BLOCK_NAME.check_address_middleform, data)));
};
export var sendYmReachGoal = function sendYmReachGoal(key, params) {
  ymPushEvent(key, params);
};